var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.19999)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.667,
    height: 26.667,
    rx: 13.333
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.167 6.667H7.5a2.5 2.5 0 0 0-2.5 2.5V17.5A2.5 2.5 0 0 0 7.5 20h11.667a2.5 2.5 0 0 0 2.5-2.5V9.167a2.5 2.5 0 0 0-2.5-2.5Zm-.342 1.667-4.9 4.9a.833.833 0 0 1-1.183 0l-4.9-4.9ZM20 17.5a.833.833 0 0 1-.833.833H7.5a.833.833 0 0 1-.833-.833V9.509l4.9 4.9a2.5 2.5 0 0 0 3.533 0l4.9-4.9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7b7c2bea9f235b1f0f9736647d75e784.svg";
export { ForwardRef as ReactComponent };